﻿
myApp.controller("expertiseCtrl", ['$scope', '$http', function ($scope, $http)
{
    angular.element(document).ready(function ()
    {
        var hash = window.location.hash.substr(1)
        if (hash != "")
        {
            var elem = $('#' + hash);
            if (elem.length>0)
            {
                $('html, body').animate({
                    scrollTop: elem.offset().top
                }, 2000);
            }
        }
    });
    $scope.setPage("expertise");//navbar action
    $scope.setPageClass("yit-what-we-do");
    $scope.specs = [];
    $scope.WaitForStrings(function () {

        var xml = this.strings;
        var expertise = $(xml).find("expertise");
        var home = $(xml).find("home");
        $scope.h1 = $(expertise).find("h1").find($scope.lang).html().trim();
        $scope.title = $(expertise).find("title").find($scope.lang).html().trim();
        $scope.cmsbtn = $(home).find("cms").find("btn").find($scope.lang).text().trim();
        
        var specs = expertise.find("spec")
        specs.each(function () {
            
            var icon = $(this).find("icon").html().trim();
            var img = $(this).find("img").html().trim();
            var id = $(this).find("id").html().trim();
            var h4 = $(this).find("h4").find($scope.lang).html().trim();
            var p = $(this).find("p").find($scope.lang).html().trim();
            var list = $(this).find("list").children();
            var isCms = h4 == "CMS";
            
            var li = [];
            list.each(function (index) {
                var text = $(this).find($scope.lang).html().trim();
                li.push(text);
            });
             
            $scope.specs.push({
                icon: icon,
                img: img,
                id: id,
                h4: h4,
                p: p,
                li: li,
                isCms: isCms
            });
        });

        $scope.setTitle($scope.title);
    }.bind($scope));
}]);
 


//////////////////
// WEBPACK FOOTER
// ../scripts/yit/pages/expertise.js
// module id = 21
// module chunks = 0